import React from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";

const BreadcrumbTextTitle = ({ title, history }) => {
    const onClickHome = () => {
        history.push("/sell-used-cars");
    };

    return (
        <ul styleName={"styles.breadCrumb"}>
            <li onClick={onClickHome}>Home</li>
            <li>{title}</li>
        </ul>
    );
};

BreadcrumbTextTitle.propTypes = {
    title: PropTypes.string,
    history: PropTypes.object
};

export default withRouter(BreadcrumbTextTitle);
